import { CardStatus } from '../../../__generated__/queries-web';

export const CARD_LIST_TABS = [
  { label: 'en ligne', status: CardStatus.Published },
  { label: 'archivé', status: CardStatus.Archived },
  { label: 'Corbeille', status: CardStatus.Deleted },
];

export const ENCARDS_LOADING_TEXT = 'Récupération des encarts ...';
export const ENCARDS_NO_RESULT_TEXT = 'Pas de résultat';
